import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import {withCookies} from 'react-cookie'

// Version logging
console.log(`%c moxtext v${process.env.APP_VERSION} (build ${process.env.APP_BUILD}) `, 'background: #222; color: #0ff; padding: 2px 6px; border-radius: 3px;')

import {Top, Sidebar, Modal, Nav} from './side'
import {getMe, getDevice, preloadImg} from './redux/actions'
import Main from './home/Main'
import Previews from './previews/Previews'

class Home extends Component {
  constructor(props) {
    super(props)
    let dir = this.props?.match?.params?.dir || ''
    let {cookies} = props
    let cookieArr = Object.values(cookies?.getAll() || {})
    this.props.set({dir, cookieArr})
    this.state = {}
  }

  componentDidMount() {
    console.log('moxtest')
    this.props.getDevice()
    if (process.env.NODE_ENV === 'development') {
      this.props.set({url: 'https://localhost:433'})
    }
    this.props.getMe()
    this.props.preloadImg()
  }

  preloadImgs = () => {}

  render() {
    let {screenHeight, showSideBar, modalShow, tab} = this.props
    let pageBlur = showSideBar || modalShow ? 'blur' : ''

    return (
      <>
        <Sidebar />
        <div
          className={`${pageBlur} page lato300 hideScroll`}
          style={{
            height: screenHeight,
            overflow: 'scroll',
          }}>
          <Top />
          <Previews />
          <Nav />
        </div>
        <Modal />
      </>
    )
  }
}

const reduxState = state => {
  return {
    network: state.network,
    screenHeight: state.screenHeight,
    showSideBar: state.showSideBar,
    solContract: state.solContract,
    address: state.address,
    modalShow: state.modalShow,
    tab: state.tab,
  }
}

const reduxDispatch = {
  set: value => ({type: 'set', payload: value}),
  getMe,
  getDevice,
  preloadImg,
}

export default withCookies(withRouter(connect(reduxState, reduxDispatch)(Home)))
